import { render, staticRenderFns } from "./ServicesSideNav.vue?vue&type=template&id=473fd908&"
import script from "./ServicesSideNav.vue?vue&type=script&lang=js&"
export * from "./ServicesSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports